import { gql } from "@apollo/client"

// Fragments
const PLOT_FRAGMENTS = {
  plotDetail: gql`
    fragment PlotDetailFrag on PlotType {
      id
      name
      farmer {
        id
        isBlocked
        blockRemark
        username
        fullName
      }
      area
      address {
        id
        latitude
        longitude
        village
        taluka
        address
        district
        pincode
        state
      }
      company {
        id
        name
      }
      codename
      soilType {
        id
        name
      }
      gatNumber
      crops {
        id
        name
        estimatedHarvestQuantity
        isFinishedGood
        isRawMaterial
        registrationCode
        isArchived
        referenceId
        alternateCropGroupId: alternateCropGroup {
          id
          name
          isRawMaterial
          isFinishedGood
        }
        variety {
          id
          name
          groups {
            id
            name
            isFinishedGood
            isRawMaterial
            codename
          }
        }
        sowingDate
        harvestingDate
        growingCycle
        numberOfSaplings
        generatePoPlotWise
        agronomist {
          id
          fullName
          createdAt
        }
      }
    }
  `,
}
const PLOT_DETAILS = gql`
  query plotDetails($id: Int) {
    plotDetails(plotId: $id) {
      ...PlotDetailFrag
    }
  }
  ${PLOT_FRAGMENTS.plotDetail}
`

const ADD_PLOT = gql`
  mutation addPlot($plot: FarmerPlotInput) {
    addUpdateOnlyPlot(plot: $plot) {
      plot {
        ...PlotDetailFrag
      }
    }
  }
  ${PLOT_FRAGMENTS.plotDetail}
`

export const CROP_VARIETIES = gql`
  query AllCropVarieties {
    allVarieties {
      id
      name
      groups {
        id
        name
        isFinishedGood
        isRawMaterial
      }
      commodity {
        id
        name
      }
    }
  }
`
export { PLOT_DETAILS, ADD_PLOT, PLOT_FRAGMENTS }
